// akun.js
import React, { useState, useEffect, useMemo, useCallback } from "react";
import "./Akun.css";
import Sidebar from "../../Component/Sidebar/Sidebar";
import Header from "../../Component/Header/Header";
import FormAkun from "./FormAkun";
import KartuAkun from "./KartuAkun";

const Akun = () => {
  const [isSidebarOpen, setIsSidebarOpen] = useState(true);

  // <=1024px dianggap mobile (mengikuti breakpoint Dashboard.css)
  const getIsMobile = () =>
    typeof window !== "undefined" &&
    window.matchMedia("(max-width: 1024px)").matches;
  const [isMobile, setIsMobile] = useState(getIsMobile());

  useEffect(() => {
    const mql = window.matchMedia("(max-width: 1024px)");
    const onChange = (e) => setIsMobile(e.matches);
    mql.addEventListener("change", onChange);
    return () => mql.removeEventListener("change", onChange);
  }, []);

  // default: desktop = open, mobile = closed
  useEffect(() => { setIsSidebarOpen(!isMobile); }, [isMobile]);

  const toggleSidebar = () => setIsSidebarOpen(v => !v);

  // Terapkan kelas DOM untuk off-canvas (mobile) + body lock
  const applyDomClasses = useCallback((open) => {
    const body = document.body;
    const sidebarEl = document.querySelector(".dashboard-page .sidebar");
    const overlayEl = document.querySelector(".sidebar-overlay");
    if (isMobile) {
      if (open) {
        sidebarEl?.classList.add("is-mobile-open");
        overlayEl?.classList.add("is-visible");
        body.classList.add("lock-scroll");
      } else {
        sidebarEl?.classList.remove("is-mobile-open");
        overlayEl?.classList.remove("is-visible");
        body.classList.remove("lock-scroll");
      }
    } else {
      sidebarEl?.classList.remove("is-mobile-open");
      overlayEl?.classList.remove("is-visible");
      body.classList.remove("lock-scroll");
    }
  }, [isMobile]);

  useEffect(() => { applyDomClasses(isSidebarOpen); }, [isSidebarOpen, applyDomClasses]);

  const handleOverlayClick = () => setIsSidebarOpen(false);

  // Kelas konten utama mengikuti Dashboard.css
  const mainContentClass = useMemo(() => {
    if (isMobile) return "main-content sidebar-closed";
    return `main-content ${isSidebarOpen ? "sidebar-open" : "sidebar-closed"}`;
  }, [isMobile, isSidebarOpen]);

  return (
    <div className="dashboard-page">
      {/* Pastikan wrapper <Sidebar /> kamu punya className="sidebar" di elemen terluar */}
      <Sidebar isOpen={isSidebarOpen} />

      {/* Overlay (lihat .sidebar-overlay di Dashboard.css) */}
      <div className="sidebar-overlay" onClick={handleOverlayClick} aria-hidden={!isSidebarOpen} />

      <div className={mainContentClass}>
        {/* Pastikan wrapper <Header /> kamu punya className="header" di elemen terluar */}
        <Header toggleSidebar={toggleSidebar} />

        <main className="page-container">
          <div className="dashboard-content-area">
            <div className="wrapper-test">
              <div className="left-wrapper">
                <section><FormAkun /></section>
              </div>
              <section><KartuAkun /></section>
            </div>
          </div>
        </main>

        <footer className="dashboard-footer">
          <p>@copyright 2025 - LacaKas</p>
        </footer>
      </div>
    </div>
  );
};

export default Akun;
